import type { ModalType } from 'src/modals/modal-manager/modal-manager';
import { SetState } from 'zustand';
import type { StoreState } from './index';

type ActiveModal =
  | {
      type: ModalType;
      props?: unknown;
      id?: number;
    }
  | Record<string, unknown>;

export type ActiveModalSlice = {
  activeModals: ActiveModal[];
  pushModal: (modal: ActiveModal) => void;
  popModal: () => void;
  clearModals: () => void;
  replaceModal: (modal: ActiveModal) => void;
};

const activeModals: ActiveModal[] = [];

// Each push gets a unique id so stacked modals of the same `type` (e.g. two LOGIN
// pushes from unrelated effects) don't collide on React's key in ModalManager.
let nextModalId = 0;

export const activeModalSlice = (set: SetState<StoreState>) => ({
  activeModals,
  pushModal: (modal: ActiveModal) => {
    set((prev) => ({
      activeModals: prev.activeModals.concat({ ...modal, id: nextModalId++ }),
    }));
  },
  popModal: () => {
    set((prev) => {
      const lastIndex = prev.activeModals.length - 1;
      return { activeModals: prev.activeModals.slice(0, lastIndex) };
    });
  },
  clearModals: () => {
    set(() => ({ activeModals: [] }));
  },
  replaceModal: (modal: ActiveModal) => {
    set((prev) => {
      const lastIndex = prev.activeModals.length - 1;
      return {
        activeModals: prev.activeModals
          .slice(0, lastIndex)
          .concat({ ...modal, id: nextModalId++ }),
      };
    });
  },
});

export const activeModalsSelector = (state: StoreState) => state.activeModals;
export const pushModalSelector = (state: StoreState) => state.pushModal;
export const popModalSelector = (state: StoreState) => state.popModal;
export const clearModalsSelector = (state: StoreState) => state.clearModals;
export const replaceModalSelector = (state: StoreState) => state.replaceModal;
